import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { getModule } from 'vuex-module-decorators';
import {
  type UserDto,
  UserService,
  type UserUiDto,
} from '@/api';
import authModule from '@/store/modules/auth';
import store from '@/store';
import SAvatars from '@/components/SAvatars/SAvatars.vue';
import { watch } from 'vue';
import i18n from '@/i18n';

interface UserSelectorProps {
  possibleOwners?: UserDto[];
  name?: boolean;
  multiple?: boolean;
  returnObject?: boolean;
  rules?: any[];
  domainId?: string;
  disabled?: boolean;
}

type UserSelectorEmits = {
  (event: 'input', value: []): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'User-Selector',
  props: {
  possibleOwners: { default: () => [] },
  name: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
  returnObject: { type: Boolean, default: false },
  rules: { default: () => [] },
  domainId: null,
  disabled: { type: Boolean, default: false }
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props;
const auth = getModule(authModule, store);





const searchString = _ref('');
let loading = _ref(false);
let users = _ref<UserDto[]>([]);

const usersKey = _computed(() => users.value.reduce((acc, user) => `${acc}${user.id}`, ''));
const hint = _computed(() => (props.multiple ? 'Select one or multiple users' : 'Select a user'));
const placeholder = _computed(() => (i18n.tc('owners.placeholder', props.multiple ? 2 : 1)));

const icon = (itemAttrs: any): string => (itemAttrs.inputValue ? 'icon-check-square-fill' : 'icon-check-square-outline-empty');
const color = (itemAttrs: any): string => (itemAttrs.inputValue ? 'iconInfo' : '');
const itemClass = (itemAttrs: any): string => (itemAttrs.inputValue ? 'primary--text v-list-item--active' : '');

const clear = () => {
  if (props.returnObject) {
    emit('input', []);
  }
};

const loadUsers = async () => {
  if (props.disabled) return;

  loading.value = true;

  // If possibleOwners are provided, use them instead of fetched users (already sorted)
  if (props.possibleOwners.length) {
    users.value = props.possibleOwners;
    loading.value = false;
    return;
  }

  // Fetch all users from the service
  const { data = [] } = await UserService.getAllUsers(props.domainId ? { domainId: props.domainId } : {});

  // Map fetched users to the desired format
  users.value = data.map((user: UserUiDto) => ({
    id: user.id,
    name: user.name,
    login: user.email,
  }));

  // Check if auth.getUser exists in the fetched data
  const isAuthUserInList = data.some((user) => user.id === auth.getUser!.id);

  // Add auth.getUser only if they're already in the fetched user list
  if (isAuthUserInList) {
    users.value = [
      auth.getUser!,
      ...data.filter((user) => user.id !== auth.getUser!.id)
        .sort((a: UserUiDto, b: UserUiDto) => a.name.localeCompare(b.name)),
    ];
  } else {
    // Otherwise, just sort the fetched users
    users.value = data.sort((a: UserUiDto, b: UserUiDto) => a.name.localeCompare(b.name));
  }

  loading.value = false;
};

watch(() => props.possibleOwners, () => {
  loadUsers();
}, { deep: true, immediate: true });

watch(() => props.domainId, () => {
  users.value = [];
  loadUsers();
});

return { __sfc: true,auth, props, emit, searchString, loading, users, usersKey, hint, placeholder, icon, color, itemClass, clear, loadUsers, _ref, _computed, getModule, UserService, authModule, store, SAvatars, watch, i18n }
}

})